import React from "react";

const TemarioPosgradoNutricionMicrobiota = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Microbiota, microbioma y metagenómica"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Definición de cada concepto. Composición de la Microbiota: géneros, especies y cepas"}</span></li>
                <li><span className="fw-light">{"Grupos de microorganismos que interaccionan con la especie humana: Bacterias, Hongos"}</span></li>
                <li><span className="fw-light">{"Virus y Protozoos Conceptos de: simbiosis, comensalismo, mutualismo, parasitismo"}</span></li>
                <li><span className="fw-light">{"Diferentes Microbiotas humanas: Generalidades"}</span></li>
                <li><span className="fw-light">{"Microbiota Gastrointestinal"}</span></li>
                <li><span className="fw-light">{"Microbiota Oral"}</span></li>
                <li><span className="fw-light">{"Microbiota de la Piel"}</span></li>
                <li><span className="fw-light">{"Microbiota del Tracto Respiratorio"}</span></li>
                <li><span className="fw-light">{"Microbiota del Tracto Urinario"}</span></li>
                <li><span className="fw-light">{"Microbiota del Aparato Reproductor"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiología en medicina"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Concepto y desarrollo de la Microbiología. Ubicación de los microorganismos en el mundo vivo"}</span></li>
                <li><span className="fw-light">{"Bacterias. Organismos Procariotas. Características generales. Metabolismo y fisiología. Genética bacteriana. Taxonomía"}</span></li>
                <li><span className="fw-light">{"Virus. Caracteres generales. Métodos de estudio. Composición química y estructura de los virus. Grupos de virus"}</span></li>
                <li><span className="fw-light">{"Hongos. Caracteres generales"}</span></li>
                <li><span className="fw-light">{"Interacciones entre microorganismos"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiota hoy"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Dieta y estilo de vida"}</span></li>
                <li><span className="fw-light">{"Eje Microbiota-Intestino-Cerebro"}</span></li>
                <li><span className="fw-light">{"Factores que influyen en el estado de la Microbiota"}</span></li>
                <li><span className="fw-light">{"Composición de la Microbiota Intestinal en las diferentes etapas de la vida"}</span></li>
                <li><span className="fw-light">{"Envejecimiento y Microbiota Actualizaciones en investigación científica ¿Qué es y para qué sirve el Trasplante fecal"}</span></li>
            </ul>
            <br /><br />
            <b>{"Aparato digestivo y homeostasis intestinal"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Fisiología del aparato digestivo. Composición de la microbiota en las diferentes partes del tubo digestivo"}</span></li>
                <li><span className="fw-light">{"Microbiota del intestino delgado en individuos sanos"}</span></li>
                <li><span className="fw-light">{"Microbiota del colon en individuos sanos"}</span></li>
                <li><span className="fw-light">{"Composición de la microbiota"}</span></li>
                <li><span className="fw-light">{"Microbiota protectora (Lactobacillus, Bifidobacterium, Bacteroides)"}</span></li>
                <li><span className="fw-light">{"Microbiota inmunomoduladora (Enterococcus faecalis y Escherichia coli)"}</span></li>
                <li><span className="fw-light">{"Microbiota muconutritiva o mucoprotectora (Faecalibacterium prausnitzii y Akkermansia muciniphila)"}</span></li>
                <li><span className="fw-light">{"Microbiota con actividades proteolítica o proinflamatoria, E. coli Biovare,Clostridium, Proteus, Pseudomonas"}</span></li>
                <li><span className="fw-light">{"Enterobacter, Citrobacter, Klebsiella, Desulfovibrio, Bilophila"}</span></li>
                <li><span className="fw-light">{"Microbiota fúngica (Candida, Geotrichum)"}</span></li>
            </ul>
            <br /><br />
            <b>{"Profundización en homeostasis intestinal"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Funciones de la microbiota intestinal: Metabólicas"}</span></li>
                <li><span className="fw-light">{"Nutritivas y Tróficas"}</span></li>
                <li><span className="fw-light">{"Protectoras y de barrera Inmunitarias"}</span></li>
                <li><span className="fw-light">{"Interrelaciones entre la microbiota intestinal y órganos alejados (cerebro, pulmón, corazón, hígado, páncreas, etc.)"}</span></li>
                <li><span className="fw-light">{"Mucosa intestinal y Sistema inmunitario de la mucosa"}</span></li>
                <li><span className="fw-light">{"Anatomía, características y funciones (Sistema MALT, GALT Y BALT)"}</span></li>
                <li><span className="fw-light">{"¿Qué es la Homeostasis intestinal? Papel de las bacterias sobre la homeostasis"}</span></li>
                <li><span className="fw-light">{"Efectos sobre la digestión y la nutrición"}</span></li>
                <li><span className="fw-light">{"Estimulación de las defensas, dificultar la colonización por microorganismos patógenos"}</span></li>
                <li><span className="fw-light">{"Producción de vitaminas de los grupos B y K"}</span></li>
                <li><span className="fw-light">{"Producción de ácidos grasos de cadena corta (butírico, propiónico, acético, etc.)"}</span></li>
                <li><span className="fw-light">{"Producción de gases (metano, dióxido de carbono, hidrógeno molecular). Propiedades y funciones"}</span></li>
                <li><span className="fw-light">{"El ácido láctico"}</span></li>
            </ul>
            <br /><br />
            <b>{"Patologías y microbiota intestinal: disbiosis intestinal y SIBO"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"¿Qué es la Disbiosis intestinal? La barrera intestinal"}</span></li>
                <li><span className="fw-light">{"Fisiología"}</span></li>
                <li><span className="fw-light">{"Función"}</span></li>
                <li><span className="fw-light">{"Permeabilidad intestinal e hiperpermeabilidad intestinal"}</span></li>
                <li><span className="fw-light">{"Relación entre Disbiosis intestinal e Hiperpermeabilidad intestinal Relación de la Disbiosis intestinal y otros tipos de desórdenes: inmunológicos"}</span></li>
                <li><span className="fw-light">{"Metabólicos, neurológicos y gástricos (Helicobacter Pylori)"}</span></li>
                <li><span className="fw-light">{"Trastornos Funcionales Digestivos"}</span></li>
                <li><span className="fw-light">{"Enfermedad inflamatoria intestinal (EII)"}</span></li>
                <li><span className="fw-light">{"Enfermedades inflamatorias crónicas intestinales: enfermedad de Crohn. Colitis ulcerosa"}</span></li>
                <li><span className="fw-light">{"3"}</span></li>
                <li><span className="fw-light">{"Síndrome de Intestino Irritable (SII)"}</span></li>
                <li><span className="fw-light">{"Marcadores de permeabilidad: Alfa 1 Antitripsina"}</span></li>
                <li><span className="fw-light">{"Zonulina"}</span></li>
                <li><span className="fw-light">{"Las Tight Juntions y su función principal"}</span></li>
                <li><span className="fw-light">{"Diveticulosis"}</span></li>
                <li><span className="fw-light">{"Diarrea. Diarrea provocada por Clostridium difficile"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiota y sistema inmunitario"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Fisiología del sistema inmunitario. Componentes del Sistema Inmunitario"}</span></li>
                <li><span className="fw-light">{"Tejido Linfoide"}</span></li>
                <li><span className="fw-light">{"Células Inmunitarias"}</span></li>
                <li><span className="fw-light">{"Sistemas Químicos"}</span></li>
                <li><span className="fw-light">{"Órganos que intervienen en la inmunidad"}</span></li>
                <li><span className="fw-light">{"Órganos primarios"}</span></li>
                <li><span className="fw-light">{"Órganos secundarios"}</span></li>
                <li><span className="fw-light">{"Inmunidad innata, inespecífica o natural"}</span></li>
                <li><span className="fw-light">{"Inmunidad adquirida, adaptativa o específica"}</span></li>
                <li><span className="fw-light">{"Relación bidireccional entre Microbiota y sistema Neuroinmunoendocrino Microbiota"}</span></li>
                <li><span className="fw-light">{"Inmunidad y Trastornos del Sistema Nervioso investigación científica"}</span></li>
            </ul>
            <br /><br />
            <b>{"Relación entre intolerancias, alergias y microbiota"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Microbiota e Intolerancias a la lactosa Microbiota e Intolerancias a las proteínas lácteas: caseínas, albúminas, etc"}</span></li>
                <li><span className="fw-light">{"Microbiota y alergias a la leche"}</span></li>
                <li><span className="fw-light">{"Microbiota e Intolerancia al gluten"}</span></li>
                <li><span className="fw-light">{"Microbiota y Enfermedad celiaca (EC)"}</span></li>
            </ul>
            <br /><br />
            <b>{"Fundamentos de alimentos funcionales y nutracéuticos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Profundizar en los probióticos"}</span></li>
                <li><span className="fw-light">{"Definición"}</span></li>
                <li><span className="fw-light">{"Historia"}</span></li>
                <li><span className="fw-light">{"Mecanismos de acción"}</span></li>
                <li><span className="fw-light">{"Probióticos en Argentina y el mundo"}</span></li>
                <li><span className="fw-light">{"Actualidad sobre Investigación científica"}</span></li>
            </ul>
            <br /><br />
            <b>{"Aplicaciones clínicas de alimentos funcionales y nutracéuticos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Productos lácteos como fuente natural de Probióticos y prebióticos"}</span></li>
                <li><span className="fw-light">{"Alimentos fermentados que impulsan una Microbiota saludable"}</span></li>
                <li><span className="fw-light">{"Taller"}</span></li>
            </ul>
            <br /><br />
            <b>{"Estrategias nutricionales con alimentos funcionales y nutracéuticos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Profundizar en los prebióticos"}</span></li>
                <li><span className="fw-light">{"Definición"}</span></li>
                <li><span className="fw-light">{"Historia"}</span></li>
                <li><span className="fw-light">{"Mecanismos de acción"}</span></li>
                <li><span className="fw-light">{"Posbioticos"}</span></li>
                <li><span className="fw-light">{"Sinbioticos"}</span></li>
                <li><span className="fw-light">{"Actualidad científica"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiota y trastornos del espectro autista"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Eje Microbiota-Intestino-Cerebro"}</span></li>
                <li><span className="fw-light">{"Microbiota & Neurodesarrollo"}</span></li>
                <li><span className="fw-light">{"Permeabilidad intestinal en niños con TEA"}</span></li>
                <li><span className="fw-light">{"Efecto Neuromodulador de los alimentos"}</span></li>
                <li><span className="fw-light">{"Factores corrosivos para el intestino"}</span></li>
                <li><span className="fw-light">{"Sensibilidad al gluten no celiaca"}</span></li>
                <li><span className="fw-light">{"Probióticos en TEA"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiota, diabetes tipo 2 y obesidad"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Etiología. Fisiopatología de la obesidad"}</span></li>
                <li><span className="fw-light">{"Relación con el microbioma y la barrera intestinal. Diagnóstico de la enfermedad: obesidad y diabetes tipo"}</span></li>
                <li><span className="fw-light">{"Bases del tratamiento de la obesidad y sus comorbilidades Tratamiento dietético aplicado a mantener una microbiota saludable"}</span></li>
                <li><span className="fw-light">{"Expectativas a futuro"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiota y patologías neurológicas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Eje Microbiota"}</span></li>
                <li><span className="fw-light">{"Intestino"}</span></li>
                <li><span className="fw-light">{"Cerebro. Neuroinflamación"}</span></li>
                <li><span className="fw-light">{"Enfermedades neurodegenerativas"}</span></li>
                <li><span className="fw-light">{"Disbiosis profunda como favorecedora en la fisiopatología"}</span></li>
                <li><span className="fw-light">{"Señales tempranas de diagnostico"}</span></li>
                <li><span className="fw-light">{"La microbiota como biomarcador precoz de enfermedad neurológica"}</span></li>
                <li><span className="fw-light">{"Actualizaciones en el tratamiento"}</span></li>
                <li><span className="fw-light">{"Microbioma-cerebro"}</span></li>
                <li><span className="fw-light">{"Psicobióticos, Depresión & Salud intestinal"}</span></li>
            </ul>
            <br /><br />
            <b>{"Vegetarianismo y veganismo"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Alimentación vegana Alimentación vegetariana"}</span></li>
                <li><span className="fw-light">{"Errores frecuentes"}</span></li>
                <li><span className="fw-light">{"Balance energético"}</span></li>
                <li><span className="fw-light">{"Buen balance del consumo de proteínas y fuentes de proteína para la microbiota"}</span></li>
                <li><span className="fw-light">{"Grasas vegetales & microbiota"}</span></li>
                <li><span className="fw-light">{"Vitaminas y minerales. Aporte correcto de Vitamina B12"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiota, embarazo y los primeros 1000 días de vida"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Simbiosis madre e hijo"}</span></li>
                <li><span className="fw-light">{"Factores influyentes en la Microbiota intestinal de la madre en la etapa gestacional y en el momento del parto"}</span></li>
                <li><span className="fw-light">{"Tipo de parto: influencia en la Microbiota del neonato"}</span></li>
                <li><span className="fw-light">{"Lactancia materna & Microbiota del bebé"}</span></li>
                <li><span className="fw-light">{"Probióticos y prebióticos en el paciente pediátrico"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiota y deporte"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Introducción al deporte de alto y bajo rendimiento"}</span></li>
                <li><span className="fw-light">{"Microbiota en la actividad deportiva de bajo rendimiento"}</span></li>
                <li><span className="fw-light">{"Inflamación crónica de bajo grado"}</span></li>
                <li><span className="fw-light">{"Microbiota en la actividad deportiva de alto rendimiento"}</span></li>
                <li><span className="fw-light">{"Taxones microbianos en el intestino del atleta"}</span></li>
                <li><span className="fw-light">{"Tratamiento terapéutico de la microbiota"}</span></li>
                <li><span className="fw-light">{"Fibra dietética. Suplementos deportivos"}</span></li>
                <li><span className="fw-light">{"Expectativas a futuro"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiota en medicina de precisión"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Elementos claves de la nutrición de precisión"}</span></li>
                <li><span className="fw-light">{"Microbiota colónica"}</span></li>
                <li><span className="fw-light">{"Nutrigenómica"}</span></li>
                <li><span className="fw-light">{"Cronobiología"}</span></li>
                <li><span className="fw-light">{"Micronutrientes"}</span></li>
                <li><span className="fw-light">{"Vitaminas: liposolubles e hidrosolubles"}</span></li>
                <li><span className="fw-light">{"Minerales"}</span></li>
                <li><span className="fw-light">{"Metales pesados y tóxicos ambientales. Incidencia en la microbiota intestinal, la salud y las enfermedades crónicas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Microbiota y enfermedad cardiovascular"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Permeabilidad intestinal. Zonulina. Endotelio vascular"}</span></li>
                <li><span className="fw-light">{"Fisiopatología de la enfermedad cardiovascular"}</span></li>
                <li><span className="fw-light">{"Herramientas diagnosticas"}</span></li>
                <li><span className="fw-light">{"Prevención & Tratamiento"}</span></li>
                <li><span className="fw-light">{"Nutrición y estilo de vida aplicadas a una microbiota saludable"}</span></li>
            </ul>
            <br /><br />
            <b>{"Histaminosis: rol de la microbiota"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Conocer fuentes de la histamina"}</span></li>
                <li><span className="fw-light">{"Diferenciar el déficit de DAO de la histaminosis alimentaria no alérgica"}</span></li>
                <li><span className="fw-light">{"Signos y síntomas"}</span></li>
                <li><span className="fw-light">{"Causas"}</span></li>
                <li><span className="fw-light">{"Herramientas para el diagnostico"}</span></li>
                <li><span className="fw-light">{"Microbiota, barrera intestinal"}</span></li>
                <li><span className="fw-light">{"Tratamiento"}</span></li>
            </ul>
            <br /><br />
            <b>{"Oncogénesis: rol de la microbiota"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Tratamiento del cáncer: evidencia de la participación de microorganismos en la generación y progresión de tumores"}</span></li>
                <li><span className="fw-light">{"Rol del microbioma"}</span></li>
                <li><span className="fw-light">{"Ca de páncreas: rol del microbioma"}</span></li>
                <li><span className="fw-light">{"Progresión epitelial del ca gástrico asociado a H. Pylori y cambios en la microbiota"}</span></li>
            </ul>
            <br /><br />
            <b>{"Lactancia materna"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Leche materna. Composición y beneficios"}</span></li>
                <li><span className="fw-light">{"Importancia de la lactancia materna y su relación con la microbiota intestinal"}</span></li>
                <li><span className="fw-light">{"Aspectos nutricionales"}</span></li>
                <li><span className="fw-light">{"Patología mamaria benigna"}</span></li>
                <li><span className="fw-light">{"Mastitis: con o sin infección"}</span></li>
                <li><span className="fw-light">{"Absceso mamario. Rol de la microbiota materna"}</span></li>
                <li><span className="fw-light">{"Microbiota de la piel materna"}</span></li>
                <li><span className="fw-light">{"Probióticos para utilización de fórmulas lácteas"}</span></li>
                <li><span className="fw-light">{"Taller"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioPosgradoNutricionMicrobiota;
